import { generateTraceContext } from "@audacia-hq/shared/utils";
import axios, { InternalAxiosRequestConfig } from "axios";

const client = axios.create();

const getAuthCookie = () => {
  const cookies = document.cookie?.split("; ") || [];
  const authCookie = cookies.find((c) => c.startsWith("auth-session="));
  return authCookie?.replace("auth-session=", "") || undefined;
};

const createRequestInterceptor = (req: InternalAxiosRequestConfig) => {
  if (req.headers && req.headers["no-auth"]) {
    req.headers.set("traceparent", generateTraceContext());
    req.headers.delete("no-auth");
    return req;
  }
  const authCookie = getAuthCookie();
  req.headers.set("traceparent", generateTraceContext());
  if (authCookie) req.headers.set("Authorization", `Bearer ${authCookie}`);
  return req;
};

client.interceptors.request.use(createRequestInterceptor);

export default client;
